import { Language } from '@/utils/language'

const localeSwitch = {
  [Language.enUS]: {
    'message.lang.tips': 'Language switch to '
  },
  [Language.zhCN]: {
    'message.lang.tips': '语言切换至 '
  },
  [Language.idID]: {
    'message.lang.tips': 'Beralih bahasa ke '
  },
  [Language.thTH]: {
    'message.lang.tips': 'การสลับภาษาเป็น'
  },
  [Language.msMY]: {
    'message.lang.tips': 'Tukar Bahasa ke '
  },
  [Language.esES]: {
    'message.lang.tips': 'Cambiar idioma a '
  }
}

export default localeSwitch
